import React from 'react';
import { useState } from 'react';

function ButtonUpload(props) {
    const [isUploaded, setIsUploaded] = useState(props.uploaded);
    const [isLoading, setIsLoading] = useState(false);
    // Create a reference to the hidden file input element
    const hiddenFileInput = React.useRef(null);
    
    // Programatically click the hidden file input element
    // when the Button component is clicked
    const handleClick = event => {
        //setIsLoading(true);
        hiddenFileInput.current.click();
    };

    const removeHandleClick = event => {
        props.removeHandleFile();
        setIsUploaded(false);
    }
    // Call a function (passed as a prop from the parent component)
    // to handle the user-selected file 
    /*const handleChange = event => {
        const fileUploaded = event.target.files[0];
        props.handleFile(fileUploaded);
        setIsUploaded(true);
    };*/

    const handleChange = async event => {
        const fileUploaded = event.target.files[0];

        //const allowedExtensions = /(\.jpeg|\.jpg|\.png|\.tiff|\.bmp)$/i;
        const allowedExtensions = /(\.pdf|\.jpeg|\.jpg|\.png|\.tiff|\.bmp)$/i;

        if(!allowedExtensions.exec(fileUploaded.name)) {
            alert('Niet ondersteund bestandsformaat. Kies een bestand met de extensie .jpeg, .jpg, .png, .tiff, of .bmp');
            return;
        }
        
        // Read the file content as a binary data
        const binaryData = await readFileAsBinary(fileUploaded);
        props.handleFile(fileUploaded, binaryData);
        setIsLoading(false);
        setIsUploaded(true);
    };

    const readFileAsBinary = file => {
        return new Promise((resolve, reject) => {

          const reader = new FileReader();

          setIsLoading(true);
          
          reader.onload = () => {
            resolve(reader.result);
          };
    
          reader.onerror = error => {
            reject(error);
            console.error('Error');
          };
    
          reader.readAsArrayBuffer(file);
        });
      };

      const spinner = <span className=" btn-upload m-0 mb-2 mt-2">
                        <div className="overlay">
                            <i className="fas fa-4x fa-sync-alt fa-spin"></i>
                        </div>
                    </span>;

    return (
        <div className="button-upload mr-3">
            <span style={{fontSize: 16}}>{props.name}</span>
                {
                    isUploaded != true ?
                        <>  {isLoading != true ?
                            <>
                                <a className="btn-upload m-0 mb-2 mt-2" onClick={handleClick}>
                                    <img src="../../dist/img/upload-icon.png" alt="AdminLTE Logo" className="brand-image" style={{opacity: '.8'}} />
                                </a>
                                <span style={{fontSize: 12, color:'#EC0000'}}>Selecteer bestand</span> 
                            </>
                                :
                                <>
                                    {spinner}
                                    <span style={{fontSize: 12, color:'#EC0000'}}>Selecteer bestand</span>
                                </>
                            }
                        </>
                    :
                        <>
                            <span className="btn-upload m-0 mb-2 mt-2">
                                <i className="fas fa-check text-success" style={{fontSize:50}}/>
                            </span>
                            <a style={{fontSize: 12, color:'#EC0000', cursor:'pointer'}} onClick={removeHandleClick}><span>Bestand verwijderen</span></a>
                        </>
                }
                <input type="file" ref={hiddenFileInput} onChange={handleChange} style={{display: 'none'}} />
            
        </div>  
          
    );
}

export default ButtonUpload;
